module.exports = __webpack_public_path__ + "static/media/3.fe931861.jpg";